import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Do Good Candle Studio — New-customers campaign (adc_zvm6avmt2f). Real lifetime
// aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS over the 16 complete months that
// reported activity between Apr 2024 and Aug 2026. Monthly series lives in
// realBrandData.ts.
//
// `startedRunningAt` is the CURRENT campaign's start, not the program's. The
// brand advertised Apr 2024 – Apr 2025 under campaigns that no longer exist,
// went dormant for thirteen months, then started this one on Jun 25, 2026. So
// every conversion below predates the campaign it now hangs off, and the gap is
// why AD_CAMPAIGNS and CAMPAIGN_PERIODS disagree about when this program began.
//
// `bestEstimateSalesDollars` equals `salesDollars` here: the one cohort is two
// years past its first twelve months, so the projection has resolved into booked
// sales rather than sitting either side of it.
export const campDgcNew: FaireAdCampaignEntity = {
  token: "camp_dgc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_do_good_candle",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 150,
  startedRunningAt: "2026-06-25",
  segmentMetrics: {
    numCustomersAcquired: 2,
    salesDollars: 1167,
    totalAdsSpendDollars: 320,
    cpaDollars: 160,
    bestEstimateSalesDollars: 1167,
    bestEstimateRoas: 3.64,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-21T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
